import { MSConstant } from '@/commons/wildcards';
import i18nEnum from '@/i18ns/vi/i18nEnum';
import i18nGlobal from '@/i18ns/i18n';
const i18n = i18nGlobal.global;
import { getCurrentInstance, ref, onMounted, watch } from 'vue';

function setup(props, { emit }) {
  //Variable
  const { proxy } = getCurrentInstance();
  //Ref data filterOperators
  let filterOperators = ref([]);

  //Giá trị ô filter
  let operatorValue = ref('');
  let operatorValueReadonly = ref(false);
  //Giá trị ô input => đặt bằng null để k trigger lần đầu khi chưa có filter
  let filterValue = ref(null);
  //ref ô input
  let filterInput = ref(null);

  // icon filter
  let nativeFilterIconClass = ref();
  let tooltipIcon = ref();

  const thEnum = ref({});

  //Method
  /**
   * Hàm set lại giá trị operator khi click thay đổi => đoạn này thêm xử lý đổi icon
   * @param {*} operator
   * HTHIEP 14.03.2022
   */
  const filterOperatorItemClick = operator => {
    let oldOperator = operatorValue.value;
    switch (operator.enumKey) {
      case 'remove':
        //Xóa filter và set lại giá trị
        removeFilter();

        //Set lại icon
        nativeFilterIconClass.value = props.filterIconClass;
        break;
      default:
        nativeFilterIconClass.value = operator.icon;
        operatorValue.value = operator.enumValue;
        tooltipIcon.value = operator.enumText;
        break;
    }

    //Trigger filter
    filterHeaderHandle({
      operator: operator.enumValue,
      value: proxy.filterValue,
      changeOperator: true,
      oldOperator: oldOperator
    });
  };

  /**
   * Lấy type column, dùng xác định xem build filter dạng gì
   * @param {*} col
   * @returns
   * HTHIEP 11.03.2022
   * nvtoan2 19/09/2023 thêm loại cho filter enum nhưng lại muốn filter theo combobox @@
   */
  const getColumnOptionType = col => {
    if (col.filterable === false) {
      return MSConstant.FormatType.None;
    } else if (col.enumName || col.enum) {
      if(col.filterCombobox) {
        return MSConstant.FormatType.Combobox;
      }
      return MSConstant.FormatType.Enum;
    }

    return col.formatType;
  };

  /**
   * Lấy dữ liệu cho cột dropdown operator
   * @param {*} col
   * @returns
   * HTHIEP 11.03.2022
   */
  const getFilterData = col => {
    const filterTextData = [
      proxy?.$ms.constant.FilterOperator.Null,
      proxy?.$ms.constant.FilterOperator.NotNull,
      proxy?.$ms.constant.FilterOperator.Equals,
      proxy?.$ms.constant.FilterOperator.NotEquals,
      proxy?.$ms.constant.FilterOperator.Contains,
      proxy?.$ms.constant.FilterOperator.Notcontains,
      proxy?.$ms.constant.FilterOperator.StartsWith,
      proxy?.$ms.constant.FilterOperator.EndsWith,
    ];
    let columnType = getColumnOptionType(col);

    if (typeof columnType === 'undefined' || columnType == null) {
      return filterTextData;
    }

    switch (columnType) {
      case proxy.$ms.constant.FormatType.None:
        return [];
      case proxy.$ms.constant.FormatType.Enum:
        return col.queryMode == 'remote' ? filterTextData : [proxy?.$ms.constant.FilterOperator.Equals, proxy?.$ms.constant.FilterOperator.NotEquals];
      case proxy.$ms.constant.FormatType.Number:
      case proxy.$ms.constant.FormatType.UnitPrice:
      case proxy.$ms.constant.FormatType.Amount:
      case proxy.$ms.constant.FormatType.ComboboxAmount:
      case proxy.$ms.constant.FormatType.Rate:
      case proxy.$ms.constant.FormatType.ExchangeRate:
      case proxy.$ms.constant.FormatType.UnitPriceOC:
      case proxy.$ms.constant.FormatType.AmountOC:
      case proxy.$ms.constant.FormatType.Allocation:
      case proxy.$ms.constant.FormatType.QuantityConvert:
      case proxy.$ms.constant.FormatType.Quantity:
        return [
          proxy?.$ms.constant.FilterOperator.Equals,
          proxy?.$ms.constant.FilterOperator.NotEquals,
          // proxy?.$ms.constant.FilterOperator.Between,
          proxy?.$ms.constant.FilterOperator.LessThan,
          proxy?.$ms.constant.FilterOperator.LessThanEquals,
          proxy?.$ms.constant.FilterOperator.GreaterThan,
          proxy?.$ms.constant.FilterOperator.GreaterThanEquals,
          proxy?.$ms.constant.FilterOperator.Null,
          proxy?.$ms.constant.FilterOperator.NotNull,
        ];
      case proxy.$ms.constant.FormatType.Date:
      case proxy.$ms.constant.FormatType.DateTime:
        case proxy.$ms.constant.FormatType.CustomTime:
        return [
          proxy?.$ms.constant.FilterOperator.Equals,
          proxy?.$ms.constant.FilterOperator.NotEquals,
          // proxy?.$ms.constant.FilterOperator.Between,
          proxy?.$ms.constant.FilterOperator.LessThan,
          proxy?.$ms.constant.FilterOperator.LessThanEquals,
          proxy?.$ms.constant.FilterOperator.GreaterThan,
          proxy?.$ms.constant.FilterOperator.GreaterThanEquals,
          proxy?.$ms.constant.FilterOperator.Null,
          proxy?.$ms.constant.FilterOperator.NotNull,
        ];
      case proxy.$ms.constant.FormatType.Checkbox:
        return [proxy?.$ms.constant.FilterOperator.Equals, proxy?.$ms.constant.FilterOperator.NotEquals];
      default:
        return filterTextData;
    }
  };

  /**
   * Lấy loại filter để hiển thị lên header
   * @param {*} col
   * @returns
   * HTHIEP 11.03.2022
   */
  const getFilterType = col => {
    let columnType = getColumnOptionType(col);

    if (typeof columnType === 'undefined' || columnType == null) {
      return proxy.$ms.constant.FilterType.msThText;
    }

    switch (columnType) {
      case proxy.$ms.constant.FormatType.Enum:
        return proxy.$ms.constant.FilterType.msThEnum;
      case proxy.$ms.constant.FormatType.Combobox:
      case proxy.$ms.constant.FormatType.ComboboxAmount:
      case proxy.$ms.constant.FormatType.ComboboxTextCustom:
        return proxy.$ms.constant.FilterType.msThCombobox;
      case proxy.$ms.constant.FormatType.Number:
      case proxy.$ms.constant.FormatType.UnitPrice:
      case proxy.$ms.constant.FormatType.Amount:
      case proxy.$ms.constant.FormatType.Rate:
      case proxy.$ms.constant.FormatType.ExchangeRate:
      case proxy.$ms.constant.FormatType.UnitPriceOC:
      case proxy.$ms.constant.FormatType.AmountOC:
      case proxy.$ms.constant.FormatType.Allocation:
      case proxy.$ms.constant.FormatType.QuantityConvert:
      case proxy.$ms.constant.FormatType.Quantity:
      case proxy.$ms.constant.FormatType.NumYear:
        return proxy.$ms.constant.FilterType.msThNumber;
      case proxy.$ms.constant.FormatType.Date:
      case proxy.$ms.constant.FormatType.DateTime:
        return proxy.$ms.constant.FilterType.msThDate;
      case proxy.$ms.constant.FormatType.Checkbox:
        return proxy.$ms.constant.FilterType.msThBoolean;
      case proxy.$ms.constant.FormatType.State:
        return proxy.$ms.constant.FilterType.msThState;
      case proxy.$ms.constant.FormatType.CustomTime:
        return proxy.$ms.constant.FilterType.msThTime;
      default:
        return proxy.$ms.constant.FilterType.msThText;
    }
  };

  /**
   * Emit event cha hứng
   * @param {*} value
   * HTHIEP 11.03.2022
   */
  const filterHeaderHandle = ({ operator, value, changeOperator, oldOperator }) => {
    if (!proxy.col.filter) {
      proxy.col.filter = {};
    }

    //Thực hiện filter nếu giá trị filter thay đổi,
    // hoặc giá trị operator thay đổi và giá trị filter không khác trắng hoặc operator bằng null hoặc not null
    if (
      operator === 'remove' ||
      value !== proxy.col.filter.value ||
      (proxy.col.filter.operator !== operator &&
        (value ||
          operator === proxy?.$ms.constant.FilterOperator.Null ||
          operator === proxy?.$ms.constant.FilterOperator.NotNull))
    ) {
      if (operator) {
        proxy.col.filter.operator = operator;
      }
      // Thêm fix giá trị để điều kiện lọc NULL hoặc NOT NULL sẽ không bị xóa
      // tbngoc 27.07.2022
      if (
        operator === proxy?.$ms.constant.FilterOperator.Null ||
        operator === proxy?.$ms.constant.FilterOperator.NotNull
      ) {
        value = 'text';
      }
      //Gán null với 1 số fomatType đặc biệt
      if (changeOperator && ( proxy.col.formatType == proxy.$ms.constant.FormatType.ComboboxTextCustom) && (proxy.col.filter.operator == proxy?.$ms.constant.FilterOperator.Contains || oldOperator == proxy?.$ms.constant.FilterOperator.Contains)) {
        proxy.filterValue = null;
        value = null;
      }


      /**
       * DQVINH CHÚ THÍCH
       * Khi lọc enum với các filter không phải là text thì value nó đang là enum => không xử lý gì cả
       * còn lọc với filter là text (filterTextData bên dưới) thì value đang là giá trị text trên bộ lọc => xử lý text thành danh sách enum
       * 
       */
      if (changeOperator && proxy.col.formatType == proxy.$ms.constant.FormatType.Enum) {
        const filterTextData = [
          proxy?.$ms.constant.FilterOperator.Contains,
          proxy?.$ms.constant.FilterOperator.Notcontains,
          proxy?.$ms.constant.FilterOperator.StartsWith,
          proxy?.$ms.constant.FilterOperator.EndsWith,
        ];
        
        if(filterTextData.includes(operator))
        {
          let listItemEnumText = [];
          let listItemEnum = proxy.$ms.constant[proxy.col.enum];
          for (let [key, val] of Object.entries(listItemEnum)) {
            listItemEnumText.push({ enum: key, enumValue: val, enumText: i18n.t('i18nEnum.' + proxy.col.enum + '.' + key) });
          }
          let filerEnum = [];
          let changeEnumToText = false; //Biến đánh dấu việc chuyển từ enum key sang text

          //Nếu giá trị truyền vào là value của enum => thực hiện convert sang text
          if(typeof value == 'number')
          {
            let objEnum = listItemEnumText.find(x => x.enumValue == value);
            value = objEnum?.enumText ?? '';
            changeEnumToText = true;
          }

          if (!filterTextData.includes(operator) && changeEnumToText == false) {
            proxy.col.filter.operator = operator;
            filerEnum = listItemEnumText.filter(x => x.enumText.toLocaleLowerCase() == value.toLocaleLowerCase());
            proxy.col.filter.value = filerEnum.length > 0 ? filerEnum.map(x => x.enumValue)[0] : '';

          } else {
            switch(operator){
            case proxy.$ms.constant.FilterOperator.Contains:
              // Lấy ra các enum có text chứa value truyền vào
              filerEnum = listItemEnumText.filter(x => x.enumText.toLocaleLowerCase().includes(value ? value.toLocaleLowerCase() : ''));
              break;
            case proxy.$ms.constant.FilterOperator.Notcontains:
              filerEnum = listItemEnumText.filter(x => !x.enumText.toLocaleLowerCase().includes(value ? value.toLocaleLowerCase() : ''));
              break;
            case proxy.$ms.constant.FilterOperator.StartsWith:
              filerEnum = listItemEnumText.filter(x => x.enumText.toLocaleLowerCase().startsWith(value ? value.toLocaleLowerCase() : ''));
              break;
            case proxy.$ms.constant.FilterOperator.EndsWith:
              filerEnum = listItemEnumText.filter(x => x.enumText.toLocaleLowerCase().endsWith(value ? value.toLocaleLowerCase() : ''));
              break;
            default:
              break;
            }
            proxy.col.filter.operator = proxy.$ms.constant.FilterOperator.In;
            proxy.col.filter.value = filerEnum.map(x => x.enumValue);
            emit('filter-header', proxy.col.filter.value);
            return;
          }
        }
      }
      else  if (changeOperator && proxy.col.formatType == proxy.$ms.constant.FormatType.ComboboxAmount) {
        value = value?.replaceAll('.', '')?.replaceAll(',', '');
      }
      // //Nếu người dùng thay đổi sang filter là = với cột combobox thì gán lại giá trị là rống
      // if(changeOperator && proxy.col.formatType==proxy.$ms.constant.FormatType.Combobox)
      // {
      //   proxy.filterValue = null;
      //   value = null;
      // }


      proxy.col.filter.value = value;
      emit('filter-header', value);
    }
  };

  /**
   * Emit event cha hứng combo enum
   * @param {*} value
   * NXCHIEN 07.06.2022
   * isFreeText = true là người dùng nhập, = false là người dùng chọn
   */
  const filterHeaderHandleEnum = (newData, { operator, value, isFreeText }) => {
    if (!proxy.col.filter) {
      proxy.col.filter = {};
    }

    if (!newData) {
      value = null;
    }

    //Thực hiện filter nếu giá trị filter thay đổi,
    // hoặc giá trị operator thay đổi và giá trị filter không khác trắng hoặc operator bằng null hoặc not null
    if (
      operator === 'remove' ||
      value !== proxy.col.filter.value ||
      (proxy.col.filter.operator !== operator &&
        (value ||
          operator === proxy?.$ms.constant.FilterOperator.Null ||
          operator === proxy?.$ms.constant.FilterOperator.NotNull))
    ) {
      // NVTUAN1 08.07.2022: Nếu là tất cả thì remove filter
      if (value === -1) {
        operator = 'remove';
      }

      if (operator) {
        proxy.col.filter.operator = operator;
      }
      const filterTextData = [
        proxy?.$ms.constant.FilterOperator.Contains,
        proxy?.$ms.constant.FilterOperator.Notcontains,
        proxy?.$ms.constant.FilterOperator.StartsWith,
        proxy?.$ms.constant.FilterOperator.EndsWith,
      ];
      if (filterTextData.includes(operator) || isFreeText) {
        let listItemEnumText = [];
        let listItemEnum = proxy.$ms.constant[proxy.col.enum];
        for (let [key, val] of Object.entries(listItemEnum)) {
          listItemEnumText.push({ enum: key, enumValue: val, enumText: i18n.t('i18nEnum.' + proxy.col.enum + '.' + key) });
        }
        let filerEnum = [];
        if (!filterTextData.includes(operator) && isFreeText) {
          proxy.col.filter.operator = operator;
          filerEnum = listItemEnumText.filter(x => x.enumText.toLocaleLowerCase() == newData.enumText.toLocaleLowerCase());
          proxy.col.filter.value = filerEnum.length > 0 ? filerEnum.map(x => x.enumValue)[0] : '';

        } else {
          switch(operator){
          case proxy.$ms.constant.FilterOperator.Contains:
            // Lấy ra các enum có text chứa value truyền vào
            filerEnum = listItemEnumText.filter(x => x.enumText.toLocaleLowerCase().includes(newData ? newData.enumText.toLocaleLowerCase() : ''));
            break;
          case proxy.$ms.constant.FilterOperator.Notcontains:
            filerEnum = listItemEnumText.filter(x => !x.enumText.toLocaleLowerCase().includes(newData ? newData.enumText.toLocaleLowerCase() : ''));
            break;
          case proxy.$ms.constant.FilterOperator.StartsWith:
            filerEnum = listItemEnumText.filter(x => x.enumText.toLocaleLowerCase().startsWith(newData ? newData.enumText.toLocaleLowerCase() : ''));
            break;
          case proxy.$ms.constant.FilterOperator.EndsWith:
            filerEnum = listItemEnumText.filter(x => x.enumText.toLocaleLowerCase().endsWith(newData ? newData.enumText.toLocaleLowerCase() : ''));
            break;
          default:
            break;
          }
          proxy.col.filter.operator = proxy.$ms.constant.FilterOperator.In;
          proxy.col.filter.value = filerEnum.map(x => x.enumValue);
        }
        emit('filter-header', proxy.col.filter.value);

      }
      else {
        proxy.col.filter.value = value;
        emit('filter-header', value);
      }
    }
  };

  /**
   * Xóa giá trị filter ở ô hiện tại
   * HTHIEP 14.03.2022
   */
  const removeFilter = trigger => {
    if (typeof proxy.filterValue !== 'undefined') {
      setDefaultFilter();
      if (trigger) {
        emit('filter-header', proxy.filterValue);
      }
    }
  };

  /**
   * Set giá trị khi filter trống
   * HTHIEP 14.03.2022
   * NCPHUOC 28/04/2022: Xóa value enum
   */
  const setEmptyFilterValue = () => {
    let columnType = getColumnOptionType(props.col);
    switch (columnType) {
      case proxy.$ms.constant.FormatType.Combobox:
      case proxy.$ms.constant.FormatType.ComboboxAmount:
      case proxy.$ms.constant.FormatType.Enum:
        filterValue.value = '';
        if (thEnum.value && typeof thEnum.value.reset === 'function') {
          thEnum.value.reset();
        }
        break;
      case proxy.$ms.constant.FormatType.Number:
      case proxy.$ms.constant.FormatType.UnitPrice:
      case proxy.$ms.constant.FormatType.Amount:
      case proxy.$ms.constant.FormatType.Rate:
      case proxy.$ms.constant.FormatType.ExchangeRate:
      case proxy.$ms.constant.FormatType.UnitPriceOC:
      case proxy.$ms.constant.FormatType.AmountOC:
      case proxy.$ms.constant.FormatType.Allocation:
      case proxy.$ms.constant.FormatType.QuantityConvert:
      case proxy.$ms.constant.FormatType.Quantity:
        filterValue.value = '';
        // proxy.filterValue = "";
        break;
      case proxy.$ms.constant.FormatType.Date:
      case proxy.$ms.constant.FormatType.DateTime:
      case proxy.$ms.constant.FormatType.Checkbox:
      case proxy.$ms.constant.FormatType.CustomTime:
        filterValue.value = null;
        // proxy.filterValue = null;
        break;
      default:
        filterValue.value = '';
        // proxy.filterValue = "";
        break;
    }
  };
  /**
   * Gán filter mặc định cho column
   * HTHIEP 14.03.2022: Bốc từ bên gridview sang bên từng cột filter
   * NCPHUOC 23/06/2022: Sửa lại cấu hình default operator theo từng column type
   * NVTUAN1 27.07.2022: Sửa lại cấu hình default operator = Equals cho column có FormatType là Enum
   */
  const setDefaultFilter = () => {
    if (!proxy.col.filter) {
      proxy.col.filter = {};
    }
    operatorValue.value = proxy.$ms.constant.FilterOperator.Equals;
    proxy.col.filter = { value: null, operator: proxy.$ms.constant.FilterOperator.Equals };
    switch (proxy.col.formatType) {
      case proxy.$ms.constant.FormatType.Text:
      case proxy.$ms.constant.FormatType.Html:

      case proxy.$ms.constant.FormatType.TextArea:
      case proxy.$ms.constant.FormatType.ComboboxMultiple:
      case proxy.$ms.constant.FormatType.Combobox:
        operatorValue.value = proxy.$ms.constant.FilterOperator.Contains;
        proxy.col.filter = { value: null, operator: proxy.$ms.constant.FilterOperator.Contains };
        break;
      case proxy.$ms.constant.FormatType.Enum:
        if (proxy.col?.queryMode == 'remote' || proxy.col?.defaultFilter == proxy.$ms.constant.FilterOperator.Contains ) {
          operatorValue.value = proxy.$ms.constant.FilterOperator.Contains;
          proxy.col.filter = { value: null, operator: proxy.$ms.constant.FilterOperator.Contains };
          break;
        }
        break;
      case proxy.$ms.constant.FormatType.ComboboxAmount:
      case proxy.$ms.constant.FormatType.Number:
      case proxy.$ms.constant.FormatType.Checkbox:
      case proxy.$ms.constant.FormatType.Datepicker:
        break;
    }
    nativeFilterIconClass.value = getFilterOperatorIcon(operatorValue.value); //Gán lại icon bên ngoài filter
    //Set giá trị về trắng khi removeFilter
    setEmptyFilterValue();
  };

  /**
   * Lấy dữ liệu operators bind lên menu dropdown
   * @param {*} enumName
   * @param {*} values
   * @returns Mảng operators
   * HTHIEP 18.03.2022
   */
  const getFilterOperators = (enumName, values) => {
    let e = MSConstant[enumName],
      arr = [];
    if (e) {
      for (const key in e) {
        if (typeof e[key] !== 'undefined') {
          let v = e[key],
            ix = -1;
          if (!values || (ix = values.indexOf(v)) > -1) {
            let enumText = i18n.t('i18nEnum.' + enumName + '.' + key);

            let item = {
              enumValue: v,
              enumKey: key,
              enumText: enumText,
              icon: getFilterOperatorIcon(v),
            };

            if (ix > -1) {
              if (arr[ix]) {
                arr[arr.length] = item;
              } else {
                arr[ix] = item;
              }
            } else {
              arr.push(item);
            }
          }
        }
      }
    }
    arr.push({
      enumValue: 'remove',
      enumKey: 'remove',
      enumText: 'Xóa điều kiện lọc',
      icon: 'ic-filter-remove',
    });
    return arr;
  };

  /**
   * Lấy thông tin icon class theo loại operator
   * @param {*} key
   * @returns
   * HTHIEP 18.03.2022
   */
  const getFilterOperatorIcon = key => {
    switch (key) {
      case proxy?.$ms.constant.FilterOperator.Contains:
       tooltipIcon.value = i18nEnum.FilterOperator.Contains;
        return 'ic-filter-contain';
      case proxy?.$ms.constant.FilterOperator.Notcontains:
       tooltipIcon.value = i18nEnum.FilterOperator.Notcontains;
        return 'ic-filter-not-contain';
      case proxy?.$ms.constant.FilterOperator.StartsWith:
       tooltipIcon.value = i18nEnum.FilterOperator.StartsWith;
        return 'ic-filter-start-with';
      case proxy?.$ms.constant.FilterOperator.EndsWith:
       tooltipIcon.value = i18nEnum.FilterOperator.EndsWith;
        return 'ic-filter-ends-with';
      case proxy?.$ms.constant.FilterOperator.Null:
       tooltipIcon.value = i18nEnum.FilterOperator.Null;
        return 'ic-filter-null';
      case proxy?.$ms.constant.FilterOperator.NotNull:
       tooltipIcon.value = i18nEnum.FilterOperator.NotNull;
        return 'ic-filter-not-null';
      case proxy?.$ms.constant.FilterOperator.Equals:
       tooltipIcon.value = i18nEnum.FilterOperator.Equals;
        return 'ic-filter-equal';
      case proxy?.$ms.constant.FilterOperator.NotEquals:
       tooltipIcon.value = i18nEnum.FilterOperator.NotEquals;
        return 'ic-filter-not-equal';
      case proxy?.$ms.constant.FilterOperator.GreaterThan:
       tooltipIcon.value = i18nEnum.FilterOperator.GreaterThan;
        return 'ic-filter-greater-than';
      case proxy?.$ms.constant.FilterOperator.GreaterThanEquals:
       tooltipIcon.value = i18nEnum.FilterOperator.GreaterThanEquals;
        return 'ic-filter-greater-than-or-eq';
      case proxy?.$ms.constant.FilterOperator.LessThan:
       tooltipIcon.value = i18nEnum.FilterOperator.LessThan;
        return 'ic-filter-less-than';
      case proxy?.$ms.constant.FilterOperator.LessThanEquals:
       tooltipIcon.value = i18nEnum.FilterOperator.LessThanEquals;
        return 'ic-filter-less-than-or-eq';
      default:
       tooltipIcon.value = i18nEnum.FilterOperator.Contains;
        return 'ic-filter-contain';
    }
  };

  //Hooks
  onMounted(() => {
    nativeFilterIconClass.value = props.filterIconClass;
  });
  /**
   * Gán dữ liệu cho dropdown operator
   * HTHIEP 14.03.2022
   */
  onMounted(() => {
    let operators = [];
    if (
      proxy.col &&
      typeof proxy?.col.operators !== 'undefined' &&
      Array.isArray(proxy?.col.operators) &&
      proxy.col.operators.length > 0
    ) {
      operators = [...proxy?.col.operators];
    } else {
      operators = [...operators, ...getFilterData(props.col)];
    }
    filterOperators.value = getFilterOperators('FilterOperator', operators);
  });

  /**
   * Set giá trị mặc định cho filter
   * HTHIEP 14.03.2022
   */
  onMounted(() => {
    setDefaultFilter();
  });

  /**
   * Thay đổi trạng thái của ô input khi đổi operator
   * HTHIEP 14.03.2022
   */
  watch(
    operatorValueReadonly,
    newValue => {
      if (newValue) {
        if (filterInput.value) {
          filterInput.value.$el.querySelector('input').setAttribute('readOnly', true);
          setEmptyFilterValue();
        }
      } else {
        if (filterInput.value) {
          filterInput.value.$el.querySelector('input').removeAttribute('readOnly');
        }
      }
    },
    {
      immediate: true,
    }
  );

  /**
   * Xem thay đổi của operator để thay đổi trạng thái của ô input
   * HTHIEP 14.03.2022
   */
  watch(
    operatorValue,
    newValue => {
      switch (newValue) {
        case proxy.$ms.constant.FilterOperator.Null:
        case proxy.$ms.constant.FilterOperator.NotNull:
          operatorValueReadonly.value = true;
          break;
        default:
          operatorValueReadonly.value = false;
          break;
      }
    },
    {
      immediate: true,
    }
  );

  return {
    nativeFilterIconClass,
    operatorValue,
    filterOperators,
    operatorValueReadonly,
    filterValue,
    filterInput,
    getFilterData,
    filterHeaderHandle,
    filterHeaderHandleEnum,
    filterOperatorItemClick,
    getFilterType,
    removeFilter,
    thEnum,
    tooltipIcon,
  };
}

export default setup;
